import React, { useEffect } from 'react';
import {
        Container, 
        Navbar, 
        Nav,
        NavDropdown,
        Button,
        Link
        } from 'react-bootstrap';

export default function NavBar() {
    useEffect(() => {
        document.title = "LSD";
    }, []);

    return (
        <Navbar bg="secondary" data-bs-theme="dark" expand="lg">
            <Container>
                <Navbar.Brand href="/">LSD</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav >
                        <Nav.Link href="/targets">Browse by Target</Nav.Link>
                        <Nav.Link href="/papers">Browse by Paper</Nav.Link>
                    </Nav>
                    <Nav className="ms-auto">
                        <NavDropdown drop='down-centered' title="Info" id="basic-nav-dropdown">
                        <NavDropdown.Item href="https://lsd.docking.org/stats/" target='_blank'>Usage</NavDropdown.Item>
                        <NavDropdown.Item href="https://wiki.docking.org/index.php/Lsd.docking.org" target='_blank'>Wiki</NavDropdown.Item>
                       
                        </NavDropdown>
                        <a href="/submit"><Button>Submit your LSD results</Button></a>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}